/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BriefType = {
    Regular: 'REGULAR',
    Strategy: 'STRATEGY'
} as const;
export type BriefType = typeof BriefType[keyof typeof BriefType];


export function instanceOfBriefType(value: any): boolean {
    for (const key in BriefType) {
        if (Object.prototype.hasOwnProperty.call(BriefType, key)) {
            // @ts-ignore
            if (BriefType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BriefTypeFromJSON(json: any): BriefType {
    return BriefTypeFromJSONTyped(json, false);
}

export function BriefTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BriefType {
    return json as BriefType;
}

export function BriefTypeToJSON(value?: BriefType | null): any {
    return value as any;
}

